import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DownloadService } from '../../profile/download.service';
import { AlbumDownloadDTO } from '../../../../../shared/album-download-dto';

@Component({
  selector: 'pv-download-row',
  templateUrl: './download-row.component.html',
  styleUrls: ['./download-row.component.scss']
})
export class DownloadRowComponent implements OnInit {
  @Input() albumId: number;
  @Input() albumDownloadDTO: AlbumDownloadDTO;
  @Output() onDownload: EventEmitter<number[]> = new EventEmitter<number[]>();
  album: AlbumDownloadDTO
  loading: boolean;
  validDownload: boolean;

  constructor(
    private downloadService: DownloadService
  ) { }

  ngOnInit() {
    if (this.albumDownloadDTO) {
      this.album = this.albumDownloadDTO;
      this.loading = false;
      this.validDownload = !!this.album
    } else {
      this.loadAlbum(this.albumId)
    }
  }

  loadAlbum(albumId: number) {
    this.loading = true;
    this.downloadService.getAlbumDownloads(albumId)
    .subscribe(album => {
      this.loading = false;
      this.validDownload = !!album;
      this.album = album;
    })
  }

  download(file) {
    if (file.url) {
      this.onDownload.emit([file.dl_zip_id, this.album.id, file.album_media_id])
    }
  }

}
